// Campus photo for /colleges/california-state-university-fullerton: CC BY-SA 4.0, by Spatms, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACal_State_Fullerton_Student_Recreation_Center_(Fullerton%2C_California).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/california-state-university-fullerton/; credited under the photo.
const photo = {
    "slug": "california-state-university-fullerton",
    "alt": "The Student Recreation Center on the Cal State Fullerton campus in Fullerton, California",
    "src": "/colleges/california-state-university-fullerton/campus-1600.webp",
    "srcSmall": "/colleges/california-state-university-fullerton/campus-800.webp",
    "srcMid": "/colleges/california-state-university-fullerton/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/california-state-university-fullerton/og.jpg",
    "title": "Cal State Fullerton Student Recreation Center (Fullerton, California)",
    "author": "Spatms",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACal_State_Fullerton_Student_Recreation_Center_(Fullerton%2C_California).jpg",
    "read": "2026-10-01"
};

export default photo;
